import * as React from 'react'

const SvgChatIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.088 18.75L10 18.125l2.5-4.375h3.75c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H3.75c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h5.625V15H3.75a2.5 2.5 0 01-2.5-2.5V5a2.5 2.5 0 012.5-2.5h12.5a2.5 2.5 0 012.5 2.5v7.5a2.5 2.5 0 01-2.5 2.5h-3.025l-2.137 3.75zM5 6.25h10V7.5H5V6.25zM5 10h6.25v1.25H5V10z"
      fill="#163250"
    />
  </svg>
)

export default SvgChatIcon
